(function () {
  if (window.__productaddonCartCleanupInitialized) return;
  window.__productaddonCartCleanupInitialized = true;

  var SOURCE = 'productaddon-cart-cleanup';

  var BUNDLE_KEY_PROP = '_productaddon_bundle_key';
  var IS_MAIN_PROP = '_productaddon_is_main';
  var IS_ADDON_PROP = 'productaddon_is_addon';

  var running = false;
  var cleanupTimeoutId = null;

  function flagTruthy(v) {
    return v === '1' || v === 1 || v === true;
  }

  /** Normalize line item properties (object or null). */
  function getProps(item) {
    if (!item || item.properties == null) return {};
    if (typeof item.properties === 'object' && !Array.isArray(item.properties)) {
      return item.properties;
    }
    return {};
  }

  /** Cart JSON URL: must respect locale / root (not hardcoded "/cart.js"). */
  function getCartJsonUrl() {
    var routes = window.MinimogSettings && window.MinimogSettings.routes;
    if (routes && routes.cart) {
      var u = String(routes.cart).split('?')[0];
      if (u.indexOf('.js') !== -1) return u;
      return (u.replace(/\/$/, '') || '') + '.js';
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!root.endsWith('/')) root += '/';
    return root + 'cart.js';
  }

  function getChangeUrl() {
    var routes = window.MinimogSettings && window.MinimogSettings.routes;
    if (routes && routes.cart_change_url) return routes.cart_change_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!root.endsWith('/')) root += '/';
    return root + 'cart/change.js';
  }

  function safeFetchJson(url, options) {
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return safeFetchJson(getCartJsonUrl(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    });
  }

  function removeCartLine(line) {
    return safeFetchJson(getChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: 0 })
    }).catch(function () {});
  }

  function getAddonRemovalLines(cart) {
    var items = cart && cart.items ? cart.items : [];
    var mainBundleKeys = new Set();

    items.forEach(function (item) {
      var props = getProps(item);
      var key = props[BUNDLE_KEY_PROP];
      if (key != null && String(key) !== '' && flagTruthy(props[IS_MAIN_PROP])) {
        mainBundleKeys.add(String(key));
      }
    });

    var lines = [];
    items.forEach(function (item, index) {
      var props = getProps(item);
      var key = props[BUNDLE_KEY_PROP];
      if (key == null || String(key) === '') return;
      if (flagTruthy(props[IS_ADDON_PROP]) && !mainBundleKeys.has(String(key))) {
        lines.push(index + 1);
      }
    });

    return lines;
  }

  function refreshCartUi() {
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate(true);
    }
    var cartPage = document.querySelector('m-cart-template');
    if (cartPage && typeof cartPage.onCartUpdate === 'function') {
      cartPage.onCartUpdate(true);
    }
  }

  /**
   * Same targets as MCartTemplate in cart.js: drawer inner vs cart page body.
   * Shows theme loader overlay and blocks interaction while add-ons are removed.
   */
  function getCartLoaderTarget() {
    var isCartPage = window.MinimogSettings && window.MinimogSettings.templateName === 'cart';
    if (isCartPage) return document.body;
    var inner = document.querySelector('.m-cart-drawer--inner');
    if (inner) return inner;
    return document.querySelector('m-cart-drawer') || document.body;
  }

  function createFallbackLoader(target) {
    var overlay = document.createElement('div');
    overlay.className = 'productaddon-cart-cleanup-overlay';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.setAttribute('aria-busy', 'true');
    var isBody = target === document.body;
    overlay.style.cssText = [
      isBody ? 'position:fixed' : 'position:absolute',
      'inset:0',
      'z-index:9999',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'background:rgba(255,255,255,0.75)',
      'pointer-events:auto',
      'cursor:wait'
    ].join(';');

    var wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:12px;color:#111;';
    wrap.innerHTML =
      '<svg class="animate-spin" style="width:32px;height:32px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
      '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
      '</svg>';
    overlay.appendChild(wrap);

    var prevPosition;
    return {
      start: function () {
        if (target !== document.body) {
          var pos = window.getComputedStyle(target).position;
          if (pos === 'static' || !pos) {
            prevPosition = target.style.position;
            target.style.position = 'relative';
          }
        }
        target.appendChild(overlay);
      },
      finish: function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        if (prevPosition !== undefined) {
          target.style.position = prevPosition;
          prevPosition = undefined;
        }
      }
    };
  }

  /** Minimog AnimateLoading (same as cart quantity updates) or DOM fallback. */
  function createCartLoader() {
    var target = getCartLoaderTarget();
    var Lib = window.MinimogLibs && window.MinimogLibs.AnimateLoading;
    if (Lib) {
      try {
        return new Lib(target, { overlay: target });
      } catch (e) {
        /* fall through */
      }
    }
    var fb = createFallbackLoader(target);
    return { start: function () { fb.start(); }, finish: function () { fb.finish(); } };
  }

  function cartUpdateTopic() {
    return (
      (window.MinimogTheme &&
        window.MinimogTheme.pubSubEvents &&
        window.MinimogTheme.pubSubEvents.cartUpdate) ||
      'cart-update'
    );
  }

  function subscribeOnce() {
    if (window.__productaddonCartCleanupSubscribed) return true;
    if (!window.MinimogEvents || typeof window.MinimogEvents.subscribe !== 'function') {
      return false;
    }
    window.__productaddonCartCleanupSubscribed = true;
    window.MinimogEvents.subscribe(cartUpdateTopic(), function (event) {
      if (event && event.source === SOURCE) return;
      scheduleCleanup();
    });
    return true;
  }

  async function cleanup() {
    if (running) return;
    running = true;

    var loader = null;
    var removedAny = false;
    var maxPasses = 30;
    var pass = 0;

    try {
      var cart = await getCart();
      var linesToRemove = getAddonRemovalLines(cart);
      if (!linesToRemove.length) {
        return;
      }

      loader = createCartLoader();
      if (loader && typeof loader.start === 'function') {
        loader.start();
      }

      while (pass++ < maxPasses) {
        cart = await getCart();
        linesToRemove = getAddonRemovalLines(cart);
        if (!linesToRemove.length) break;

        linesToRemove.sort(function (a, b) {
          return b - a;
        });
        await removeCartLine(linesToRemove[0]);
        removedAny = true;
      }

      if (removedAny) {
        refreshCartUi();
        if (window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
          window.MinimogEvents.emit(cartUpdateTopic(), { source: SOURCE });
        }
      }
    } catch (e) {
      /* ignore */
    } finally {
      if (loader && typeof loader.finish === 'function') {
        try {
          loader.finish();
        } catch (finishErr) {
          /* ignore */
        }
      }
      running = false;
    }
  }

  function scheduleCleanup() {
    if (cleanupTimeoutId) clearTimeout(cleanupTimeoutId);
    cleanupTimeoutId = setTimeout(function () {
      cleanup();
    }, 200);
  }

  subscribeOnce();
  document.addEventListener('DOMContentLoaded', subscribeOnce);
  setTimeout(subscribeOnce, 0);
  setTimeout(subscribeOnce, 500);
})();
